import { motion } from "framer-motion";
import React from "react";
import Quantity from "../../modules/Quantity";
import { useCart, useRecharge } from "../../../hooks";
import DeleteItem from "./DeleteItem";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.07,
    },
  },
};

const listItem = {
  hidden: { opacity: 0, y: -32, scale: 0.98, ease: "easeIn" },
  show: { delay: 3, opacity: 1, y: 0, scale: 1, ease: "easeOut" },
};

export default function LineItemSlideOut({ item }) {
  const { updateCartItemQty } = useCart();
  const { getFrequencyFromCustomAttributes } = useRecharge();

  const subscriptionFrequency = getFrequencyFromCustomAttributes(
    item.customAttributes
  );

  const isDiscounted = item.discountAllocations.length ? true : false;
  const discountPrice = isDiscounted ? ((item.variant.price * item.quantity) - item.discountAllocations[0].allocatedAmount.amount) : '';

  return (
    <div className="flex items-center py-sm border-b-2">
      {/* Image */}
      <motion.div className="relative w-24 h-24 mr-sm bg-primary rounded-md overflow-hidden">
        <img
          className="top-0 w-full h-full min-h-1/2 object-cover absolute z-0"
          src={item.variant.image.src}
          alt=""
        />
      </motion.div>
      {/* text container */}
      <motion.div
        initial="hidden"
        animate="show"
        variants={container}
        className="flex flex-col gap-xs "
      >
        {/* Title */}
        <motion.p variants={listItem} className="hds-copy font-bold">
          {item.title}
        </motion.p>
        {/* Variant Title */}
        <motion.div variants={listItem} className="">
          {item.variant.title !== 'Default Title' ? item.variant.title : ''}
        </motion.div>
        {/* Quantity */}
        <motion.div variants={listItem} className="">
          <Quantity
            value={item.quantity}
            update={updateCartItemQty}
            itemId={item.id}
          />
        </motion.div>
        {/* Price */}
        <motion.p variants={listItem} className="text-sm">
          <span className={`${isDiscounted ? 'line-through	' : 'font-bold'}`}>
            ${(item.variant.price * item.quantity).toFixed(2)}
          </span>

          {isDiscounted && (
            <span className="ml-4 font-bold">
              {(discountPrice !== 0 ? `$${discountPrice.toFixed(2)}` : 'Free')}
            </span>
          )}
        </motion.p>
        {/* Subscription Frequency */}
        {subscriptionFrequency && (
          <motion.p variants={listItem} className="text-sm ">
            Deliver every {subscriptionFrequency}
          </motion.p>
        )}
      </motion.div>
      {/* Delete */}
      <div className="flex flex-col justify-center">
        <DeleteItem itemId={item.id} />
      </div>
    </div>
  );
}
